import { render, staticRenderFns } from "./RegisterModule.vue?vue&type=template&id=7493651a&scoped=true&"
import script from "./RegisterModule.vue?vue&type=script&lang=js&"
export * from "./RegisterModule.vue?vue&type=script&lang=js&"
import style0 from "./RegisterModule.vue?vue&type=style&index=0&id=7493651a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7493651a",
  null
  
)

export default component.exports